module.exports = __webpack_public_path__ + "img/spa-reception.b74ffb16.svg";